"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.swirl = exports.standardTail = exports.standardHotspot = exports.speechBubble = exports.pulse = exports.plus = exports.heartbeat = exports.defaultHotspot = exports.directSum = exports.diamond = exports.countdown = exports.clock = exports.custom = exports.circle = exports.boundingBox = exports.bigPulse = exports.bigButton = void 0;

var _hotspotGlobal = require("./hotspot.global.styles"); // TODO: Align this file with Studio


var bigButton = {
  backgroundColor: _hotspotGlobal.colors.alabaster,
  color: _hotspotGlobal.colors.black,
  hoverStyle: {
    backgroundColor: _hotspotGlobal.colors.black,
    color: _hotspotGlobal.colors.sunsetOrange
  }
};
exports.bigButton = bigButton;
var bigPulse = {
  primaryColor: _hotspotGlobal.colors.iron,
  secondaryColor: _hotspotGlobal.colors.iron
};
exports.bigPulse = bigPulse;
var boundingBox = {
  backgroundColor: _hotspotGlobal.colors.transparent,
  borderColor: _hotspotGlobal.colors.alto,
  borderRadius: 0,
  borderStyle: 'solid',
  borderWidth: 1,
  opacity: _hotspotGlobal.opacity,
  hoverStyle: {
    backgroundColor: _hotspotGlobal.colors.transparent,
    borderColor: _hotspotGlobal.colors.white,
    borderRadius: 0,
    borderStyle: 'solid',
    borderWidth: 1
  }
};
exports.boundingBox = boundingBox;
var circle = {
  iconSize: 'medium',
  opacity: 0.55,
  primaryColor: _hotspotGlobal.colors.white,
  transform: 'scale(1)',
  transition: _hotspotGlobal.transition,
  hoverStyle: {
    iconSize: 'large',
    opacity: 0.8,
    primaryColor: _hotspotGlobal.colors.white,
    transform: 'scale(1)'
  }
};
exports.circle = circle;
var custom = {
  backgroundColor: _hotspotGlobal.colors.transparentBlack,
  backgroundImage: 'https://d1qb2nb5cznatu.cloudfront.net/startups/i/54043-a7e866277352094fceffa959a8a0c191-medium_jpg.jpg?buster=1542029209',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  borderColor: _hotspotGlobal.colors.transparentBlack,
  borderRadius: '0%',
  borderStyle: 'solid',
  borderWidth: 0,
  boxShadow: '0px 0px 0px 0px transparent',
  height: '50px',
  opacity: _hotspotGlobal.opacity,
  transition: 'all 200ms ease',
  width: '50px',
  hoverStyle: {
    borderColor: _hotspotGlobal.colors.black,
    borderRadius: '10%',
    borderWidth: '2px',
    boxShadow: '0px 0px 0px 0px transparent',
    height: '70px',
    opacity: _hotspotGlobal.opacity,
    transition: 'all 200ms ease',
    width: '70px'
  }
};
exports.custom = custom;
var clock = {
  primaryColor: _hotspotGlobal.colors.white
};
exports.clock = clock;
var countdown = {
  borderColor: _hotspotGlobal.colors.white,
  circleColor: _hotspotGlobal.colors.white,
  opacity: _hotspotGlobal.opacity
};
exports.countdown = countdown;
var diamond = {
  iconColor: _hotspotGlobal.colors.black,
  backgroundColor: _hotspotGlobal.colors.sunglow,
  borderColor: _hotspotGlobal.colors.sunglow,
  hoverStyle: {
    iconColor: _hotspotGlobal.colors.black,
    backgroundColor: _hotspotGlobal.colors.sunglow,
    borderColor: _hotspotGlobal.colors.sunglow
  }
};
exports.diamond = diamond;
var directSum = {
  iconSize: 'medium',
  opacity: _hotspotGlobal.opacity,
  primaryColor: _hotspotGlobal.colors.white,
  secondaryColor: _hotspotGlobal.colors.black,
  strokeWidth: 3,
  transform: 'scale(1)'
};
exports.directSum = directSum;
var defaultHotspot = {
  backgroundColor: _hotspotGlobal.colors.codGray,
  borderColor: _hotspotGlobal.colors.white,
  borderStyle: 'dashed',
  borderWidth: 1,
  color: _hotspotGlobal.colors.white,
  transition: _hotspotGlobal.transition,
  hoverStyle: {
    backgroundColor: _hotspotGlobal.colors.white,
    borderColor: _hotspotGlobal.colors.white,
    borderStyle: 'solid',
    borderWidth: 2,
    color: _hotspotGlobal.colors.codGray,
    opacity: _hotspotGlobal.opacity
  }
};
exports.defaultHotspot = defaultHotspot;
var heartbeat = {
  iconSize: 'medium',
  opacity: _hotspotGlobal.opacity,
  primaryColor: _hotspotGlobal.colors.pomegranate,
  secondaryColor: _hotspotGlobal.colors.white,
  transform: 'scale(1)'
};
exports.heartbeat = heartbeat;
var plus = {
  iconSize: 'medium',
  opacity: _hotspotGlobal.opacity,
  primaryColor: _hotspotGlobal.colors.white,
  secondaryColor: _hotspotGlobal.colors.alto
};
exports.plus = plus;
var pulse = {
  opacity: _hotspotGlobal.opacity,
  primaryColor: _hotspotGlobal.colors.alabaster,
  secondaryColor: _hotspotGlobal.colors.alabaster
};
exports.pulse = pulse;
var speechBubble = {
  backgroundColor: _hotspotGlobal.colors.white,
  color: _hotspotGlobal.colors.black,
  iconColor: _hotspotGlobal.colors.black,
  hoverStyle: {
    backgroundColor: _hotspotGlobal.colors.black,
    color: _hotspotGlobal.colors.white,
    iconColor: _hotspotGlobal.colors.white
  }
};
exports.speechBubble = speechBubble;
var standardHotspot = {
  backgroundColor: _hotspotGlobal.colors.black,
  color: _hotspotGlobal.colors.white,
  opacity: _hotspotGlobal.opacity
};
exports.standardHotspot = standardHotspot;
var standardTail = {
  backgroundColor: _hotspotGlobal.colors.black,
  borderColor: _hotspotGlobal.colors.whiteRock,
  borderRadius: '0%',
  borderStyle: 'solid',
  borderWidth: '1px',
  color: _hotspotGlobal.colors.whiteRock,
  opacity: _hotspotGlobal.opacity
};
exports.standardTail = standardTail;
var swirl = {
  primaryColor: _hotspotGlobal.colors.dodgerBlue,
  secondaryColor: _hotspotGlobal.colors.dodgerBlue
};
exports.swirl = swirl;